import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getForSearch = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LogFasttrack/Search", params);
};

const getForSearchAuthen = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LogFasttrack/SearchAuthen", params);
};

const getForSearchError = (params) => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/LogFasttrack/SearchError", params);
};

export { getForSearch, getForSearchAuthen, getForSearchError };